import { format, isBefore, isEqual, parse, startOfDay } from "date-fns"

export const calculateSummaryTotals = (invoices = []) => {
  const totalCents = invoices
    .map((i) => i.totalAmount)
    .reduce((a, b) => a + b, 0)

  const paidInvoices = invoices.filter((i) => i.balance === 0)
  const paidCents = paidInvoices
    .map((i) => i.totalAmount)
    .reduce((a, b) => a + b, 0)

  const unpaidInvoices = invoices.filter((i) => i.balance > 0)
  const unpaidCents = unpaidInvoices
    .map((i) => i.balance)
    .reduce((a, b) => a + b, 0)

  const dueNowInvoices = unpaidInvoices.filter((i) => {
    const dueDate = startOfDay(parse(i.dueDate, "yyyy-MM-dd", new Date()))
    const today = startOfDay(new Date())

    return isEqual(dueDate, today) || isBefore(dueDate, today)
  })
  const dueNowCents = dueNowInvoices
    .map((i) => i.balance)
    .reduce((a, b) => a + b, 0)

  return {
    totalCents,
    paidCents,
    unpaidCents,
    dueNowCents,
  }
}

export const getDateFilterText = (startDate, endDate) => {
  if (startDate && !endDate) {
    return `Due Date On or After: ${format(startDate, "MM/dd/yyyy")}`
  } else if (endDate && !startDate) {
    return `Due Date On or Before: ${format(endDate, "MM/dd/yyyy")}`
  } else if (endDate && startDate) {
    return `Due Date Between: ${format(startDate, "MM/dd/yyyy")} - ${format(
      endDate,
      "MM/dd/yyyy"
    )}`
  }
}
